"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useRestore(environment) {
    var _a = react_1.useState(environment.isRehydrated()), rehydratate = _a[0], setRehydratate = _a[1];
    if (!rehydratate) {
        environment.hydrate().then(function () { return setRehydratate(environment.isRehydrated()); });
    }
    return rehydratate;
}
exports.useRestore = useRestore;
